import { type ContentfulClientApi, type SelectFilterPaths } from 'contentful';

import { ContentSlotType } from '../../models/Content';
import { TypeContentSlotFields, TypeContentSlotSkeleton } from '../../models/Generated';
import { getContentfulClientCSR } from '../../utils/contentfulClientCSR';

type Options<Fields extends Record<string, any> = {}> = {
    select?: SelectFilterPaths<Fields, 'fields'>[];
    client: Promise<ContentfulClientApi<undefined>>;
};

const loadContentSlot = async (
    identifier: string,
    options: Options<TypeContentSlotFields>,
): Promise<ContentSlotType | null> => {
    const client = await options.client;
    const response = await client.withoutUnresolvableLinks.getEntries<TypeContentSlotSkeleton>({
        content_type: 'contentSlot',
        select: options?.select,
        'fields.identifier': identifier,
        include: 10,
        limit: 1,
    });

    return response?.items?.[0] || null;
};

export const loadContentSlotData = (identifier: string) =>
    loadContentSlot(identifier, {
        client: getContentfulClientCSR(),
        select: ['fields.identifier', 'fields.contents'],
    });
